module.exports = __webpack_public_path__ + "img/logo-esiea-bg.29b7b616.svg";